export default "__VITE_ASSET__HqBpE9A8__";